import { Close, Search } from "@mui/icons-material";
import { Button, Dialog, DialogContent, Divider, IconButton, InputAdornment } from "@mui/material";
import React from "react";
import BTNLoader from "../../../lib/components/BTNLoader";
import AppTextField from "../../../lib/components/AppTextField";
import { useQuery } from "@tanstack/react-query";
import organizationservice from "../../../service/organizationservice";
import useDebounce from "../../../hooks/useDebounce";
import _ from "lodash";

const SelectOrganization = ({ isOpen, onClose, currentStep, isLoading, organization, handleSelectOrganization }) => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const keyword = useDebounce(searchTerm);

  const organizationsQuery = useQuery({
    enabled: currentStep === 1,
    queryKey: ["organizations", keyword],
    queryFn: () => organizationservice.get({ keyword }),
  });

  if (currentStep !== 1) return null;

  const organizationData = organizationsQuery?.data?.data?.data;

  return (
    <Dialog onClose={onClose} open={isOpen} maxWidth="xs" PaperProps={{ className: "w-100" }}>
      <React.Fragment>
        <div className="d-flex justify-content-between align-items-center gap-4 p-3 py-2 pe-2">
          <div className="fs-5 fw-medium">Select Organization</div>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
        <Divider className="bg-secondary-subtle" />
        <div className="my-4 px-4">
          <AppTextField
            placeholder="Search organizations..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search className="text-secondary" />
                </InputAdornment>
              ),
            }}
          />
        </div>
      </React.Fragment>

      <DialogContent>
        <div>
          {organizationData?.map((item) => (
            <div key={item?.id} className="d-flex justify-content-between align-items-center gap-4 py-3">
              <div>
                <div>{item?.name}</div>
                {!item?.subscription ? null : (
                  <div className="fs-xs text-secondary">
                    {item?.subscription?.planName} ({_.capitalize(item?.subscription?.billingInterval)})
                  </div>
                )}
              </div>
              <Button
                onClick={() => handleSelectOrganization(item)}
                variant="outlined"
                color="secondary"
                sx={{ width: 120 }}
                disabled={isLoading || item?.meta?.integration?.firs?.connected}
                startIcon={organization?.id === item?.id ? <BTNLoader isLoading={isLoading} /> : null}
              >
                {item?.meta?.integration?.firs?.connected ? "Connected" : "Connect"}
              </Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SelectOrganization;
